// Dependencies
import { h, Fragment } from "preact";
import { connect } from "react-redux";
import _ from "lodash";

// Components
import { Form, Row, Col, I18n, Button} from "components/elements";
import LoadingIcon from 'components/elements/LoadingIcon';
import WidgetComponent from "components/WidgetComponent";
import { TimeSlotsCard } from "components/partials";
import { PatientSelect } from "components/partials";
import { Container } from "components/elements";

// Styles
import style from "./style.less";

// Helpers
import { ProcessTimeSlots, pile } from "lib/helpers";
import dayjs from "lib/helpers/dayjs";
import { times } from "lib/helpers";
import {PageActions, SelectedPatientActions} from 'actions';

// Actions
import {
	ServiceRegionActions,
	AvailabilityActions,
	ShiftActions,
	TimeSlotActions,
	SelectedTimeSlotActions,
	FilterActions,
} from "actions";

import LoadingActions from "actions/LoadingActions";


// Icons
import arrowDownIcon from "../../../assets/icons/arrow_down.svg";
import Calendar from "components/elements/Calendar";
import chevronLeft from "../../../assets/icons/svg/chevron_left.svg"


// Class Component
@Form
@connect((state) => ({
	...state,
}))
export default class TimeSlots extends WidgetComponent {

	// Constructor
	constructor() {
		super();
		this.state = {
			processing: true,
			outOfSlots: {},
			serviceRegionIDs: [],
            deployCalendar: false,
		};
		this.proceed = this.proceed.bind(this);
		this.getTimeSlots = this.getTimeSlots.bind(this);
		this.getAdminTimeSlots = this.getAdminTimeSlots.bind(this);
		this.updateDate = this.updateDate.bind(this);
		this.isAllInfoGathered = this.isAllInfoGathered.bind(this);
		this.handleTimeSlotSelect = this.handleTimeSlotSelect.bind(this);
		this.handleDates = this.handleDates.bind(this);
		this.handleSkipToNext = this.handleSkipToNext.bind(this);
		this.handleBackButton =
			this.handleBackButton.bind(this);
		this.handlePatientSelect = this.handlePatientSelect.bind(this);
	}

	// Hook Methods
	componentWillReceiveProps(newProps) {
		if (
			_.difference(
				Object.keys(newProps.selectedPatients),
				Object.keys(this.props.selectedPatients)
			).length > 0
		) {
			if (
				newProps.filters.patientCount ==
					Object.keys(newProps.selectedPatients).length &&
				newProps.selectedTimeSlot.id
			) {
				this.proceed();
			} else if (this.hasRestrictions) {
				AvailabilityActions.clear();

				this.getTimeSlots(Object.values(newProps.selectedPatients || {}));
			}
		}
	}

	componentDidUpdate(prevProps, prevState) {
        if(prevState.processing !== this.state.processing){
			LoadingActions.append({timeSlots: this.state.processing})
		}	
    }

	componentDidMount() {
        if(this.state.processing){
			LoadingActions.append({timeSlots: true})
		}
    }

	componentWillMount() {
		super.componentWillMount();
		let _outOfSlots = {};
		this.administrators.forEach((admin) => {
			_outOfSlots[admin.id] = false;
		});

		if (Object.keys(this.props.serviceRegions).length > 0) {
			this.setState({
				loadingRegions: true,
				processing: true,
			});
			ServiceRegionActions.fetch({
				organizationID: this.organization.id,
				accountID: this.props.session.accountID,
			}).then((res) => {
				this.setState({
					outOfSlots: _outOfSlots,
					serviceRegionIDs: res.data.map((serviceRegion) => serviceRegion.id),
					loadingRegions: false,
				});

				this.getTimeSlots();
			});
		} else {
			this.setState({
				outOfSlots: _outOfSlots,
				serviceRegionIDs: Object.keys(this.props.serviceRegions),
			});

			this.getTimeSlots();
		}
	}

	// Methods
	proceed() {
		super.componentDidSubmit();
	}

	getTimeSlots(patients) {
		let availabilities = this.availabilities;
		this.setState({
			processing: true,
		});

		if (!patients) {
			patients = Object.values(this.props.selectedPatients || {});
		}

		if (this.hasRestrictions && patients.length == 0) {
			TimeSlotActions.set([]);
			this.setState({
				processing: false,
			});
			return;
		}
		let startDate = this.startDate.startOf("day");
		let thisDay_week = startDate.clone().startOf("week").format();
		let nextDay_week = startDate.clone().add(1, "day").startOf("week").format();

		let availabilitiesReceived =
			(this.props.filters || {}).availabilitiesReceived || [];
		let startingAt, endingAt;

		if (!availabilitiesReceived.includes(thisDay_week)) {
			startingAt = dayjs(thisDay_week).startOf("day").format();
			endingAt = dayjs(thisDay_week).endOf("week").format();
			availabilitiesReceived.push(thisDay_week);
		}

		if (!availabilitiesReceived.includes(nextDay_week)) {
			if (!startingAt) {
				startingAt = dayjs(nextDay_week).startOf("day").format();
			}
			endingAt = dayjs(nextDay_week).endOf("week").format();
			availabilitiesReceived.push(nextDay_week);
		}

		if (!startingAt) {
			let serviceRegionIDs;
			if (Object.keys(this.props.serviceRegions).length > 0) {
				serviceRegionIDs = this.state.serviceRegionIDs;
			}

			TimeSlotActions.set(
				ProcessTimeSlots.all({
					startingAt: startDate.format(),
					data: availabilities,
					shifts: this.props.shifts,
					widgetAvailability: this.organization.widgetAvailability,
					appointmentType:
						this.props.appointmentTypes[this.props.filters.appointmentTypeID],
					patientCount: this.props.filters.patientCount,
					administrators: this.props.administrators,
					serviceRegionIDs,
					patients,
				})
			);

			this.setState({
				processing: false,
			});
		} else {
			pile(
				{},
				{
					availabilities: AvailabilityActions.fetch({
						organizationID: this.organization.id,
						appointmentTypeID: this.props.filters.appointmentTypeID,
						startingAt,
						endingAt,
						accountID: this.props.session.accountID,
					}),
					shifts: ShiftActions.fetch({
						organizationID: this.organization.id,
						startingAt,
						endingAt,
						active: true,
					}),
				}
			).then((response) => {
				if (this.state.processingTimeout) {
					clearTimeout(this.state.processingTimeout);
				}
				this.setState({
					processing: true,
					processingTimeout: setTimeout(() => {
						this.setState({
							processing: false,
						});
					}, 300),
				});

				const _data = [...response.availabilities.data];
				availabilities = availabilities.concat(_data);

				let data = {};
				for (let item of _data) {
					data[item.id] = item;
				}

				AvailabilityActions.appendMany(data);

				FilterActions.set({
					...this.props.filters,
					availabilitiesReceived,
				});

				let serviceRegionIDs;
				if (Object.keys(this.props.serviceRegions).length > 0) {
					serviceRegionIDs = this.state.serviceRegionIDs;
				}
				TimeSlotActions.set(
					ProcessTimeSlots.all({
						startingAt: startDate.format(),
						data: availabilities,
						shifts: this.props.shifts,
						widgetAvailability: this.organization.widgetAvailability,
						appointmentType:
							this.props.appointmentTypes[this.props.filters.appointmentTypeID],
						patientCount: this.props.filters.patientCount,
						administrators: this.props.administrators,
						serviceRegionIDs,
						patients,
					})
				);
				this.setState({
					processing: false,
				});
			});
		}
	}

	isTimeSlotSelected() {
		return !!(this.props.selectedTimeSlot || {}).id;
	}

	isAllInfoGathered() {
		return (
			this.isTimeSlotSelected() &&
			this.props.filters.patientCount ==
				Object.keys(this.props.selectedPatients).length
		);
	}

	updateDate(date) {
		let _outOfSlots = { ...this.state.outOfSlots };
		Object.keys(_outOfSlots).forEach((key) => {
			_outOfSlots[key] = false;
		});
		this.setState({
			outOfSlots: _outOfSlots,
		});

		let data = this.props.filters;
		data.startDate = dayjs(date).format();
		delete data.date;

		this.setState({
			startDate: data.startDate,
		});

		this.getTimeSlots();
	}

	getAdminTimeSlots(administrator) {
		return Object.values(this.props.timeSlots[administrator.id] || {});
	}

	handleTimeSlotSelect(e) {
		e.preventDefault();
		let administratorID = e.target.id.split("--")[0];
		let timeSlot = this.props.timeSlots[administratorID][e.target.id];
		SelectedTimeSlotActions.set(timeSlot);

		if (
			this.props.filters.patientCount ==
			Object.keys(this.props.selectedPatients).length
		) {
			this.proceed();
		}
	}

	handleDates (newDate){
		if(this.state.deployCalendar){
			this.setState({
				deployCalendar: false,
			});
		}
		this.updateDate(newDate);
	}

	handleSkipToNext(administrator) {
		let filterDate = dayjs((this.props.filters || {}).startDate).add(1, "day");
		if (filterDate.isAfter(dayjs().add(6, "months"))) {
			return false;
		}
		if (filterDate.isBefore(dayjs())) {
			filterDate = dayjs();
		}

		let appointmentTypeID = this.props.filters.appointmentTypeID || "";
		let appointmentType = this.props.appointmentTypes[appointmentTypeID];
		let duration =
			appointmentType.durations.split(",")[this.props.filters.patientCount - 1];

		AvailabilityActions.fetch({
			organizationID: this.organization.id,
			findNext: true,
			startingAt: filterDate.format(),
			administratorID: administrator.id,
			duration,
		}).then((response) => {
			let _outOfSlots = { ...this.state.outOfSlots };

			if (response.data[0]) {
				this.updateDate(dayjs(response.data[0].startsAt).format());
				_outOfSlots[administrator.id] = false;
			} else {
				_outOfSlots[administrator.id] = true;
			}

			this.setState({
				outOfSlots: _outOfSlots,
			});
		});
	}

	handleBackButton() {
		if(this.hasRestrictions){
			if(this.shouldShowAppointments){
				SelectedPatientActions.clear();
			}
			if(this.shouldShowPatients){
				PageActions.reset();
			}

		} else {
			if(this.shouldShowAppointments){
				PageActions.reset();
			}
			if(this.shouldShowPatients){
				SelectedTimeSlotActions.set({});
			}
		}
	}

	handlePatientSelect() {
		if (this.hasRestrictions) {
			FilterActions.set({
				...this.props.filters,
				availabilitiesReceived: [],
			});
			AvailabilityActions.set({});
			TimeSlotActions.set([]);
		}
	}

	setAdministrator(administratorID) {
		FilterActions.merge({
			selectedAdministratorID: administratorID,
		});
	}

	// Getters
	get shouldShowPatients() {
		if (this.hasRestrictions) {
			return !!this.appointmentType.id && !(this.props.filters.patientCount ==
			Object.keys(this.props.selectedPatients).length) ;
		} else {
			return this.isTimeSlotSelected();
		}
	}

	get shouldShowAppointments() {
		if (this.hasRestrictions) {
			return (
				this.props.filters.patientCount ==
				Object.keys(this.props.selectedPatients).length
			);
		} else {
			return !!this.appointmentType.id && !this.isTimeSlotSelected();
		}
	}

	get timeSlots() {
		return this.props.timeSlots;
	}

	get condensedTimeSlots() {
		let timeSlots = {};
		let adminTimeSlots = this.timeSlots;
		Object.keys(adminTimeSlots).forEach((adminKey) => {
			if (
				this.props.administrators[adminKey] &&
				this.props.administrators[adminKey].provider &&
				this.props.administrators[adminKey].appointmentTypeIDs.includes(
					this.props.filters.appointmentTypeID
				)
			) {
				Object.keys(adminTimeSlots[adminKey]).forEach((key) => {
					let timeSlot = adminTimeSlots[adminKey][key];
					let splitKey = key.split("--");
					let tempKey = `${splitKey[1]}--${splitKey[2]}`;
					if (!timeSlots[tempKey]) {
						timeSlots[tempKey] = timeSlot;
					}
				});
			}
		});

		return Object.values(timeSlots);
	}
	

	get widgetSettings() {
		return (this.organization || {}).widgetSettings || {};
	}

	get startDate() {
		return dayjs(this.props.filters.startDate || "").startOf("day");
	}

	get availabilities() {
		return Object.entries(this.props.availabilities || {}).map(([, _]) => _);
	}

	get patients() {
		return Object.values(this.props.patients || {});
	}

	get administrators() {
		return Object.values(this.props.administrators || {})
			.filter((admin) => {
				let appointmentTypeMatch =
					!this.props.filters.appointmentTypeID ||
					admin.appointmentTypeIDs.includes(
						this.props.filters.appointmentTypeID
					);
				let patientCountAllowed =
					this.props.filters.patientCount <=
					(admin.administratorOptions.maxPatientsPerVisit || 1);
				if (Object.keys(this.props.serviceRegions).length > 0) {
					let inRegion =
						_.intersection(this.state.serviceRegionIDs, admin.serviceRegions)
							.length > 0;
					if (!inRegion) return false;
				}
				if (appointmentTypeMatch && patientCountAllowed) {
					return true;
				}
				return false;
			})
			.sort((a, b) => {
				if (a.lastName > b.lastName) return 1;
				if (a.lastName < b.lastName) return -1;
				if (a.firstName > b.firstName) return 1;
				if (a.firstName < b.firstName) return -1;
				return 0;
			});
	}

	get appointmentTypes() {
		return Object.values(this.props.appointmentTypes || {}).filter(
			(appType) => {
				if (
					appType.userType &&
					((!(this.props.session || {}).accessToken &&
						appType.userType == "returning") ||
						((this.props.session || {}).accessToken &&
							appType.userType == "new"))
				) {
					return false;
				}
				let maxPatients = 1;
				if (appType.durations) {
					maxPatients = appType.durations.split(",").length;
				}
				if (
					!this.props.filters.patientCount ||
					this.props.filters.patientCount <= maxPatients
				) {
					return true;
				}
				return false;
			}
		);
	}
	
	get appointmentType() {
		return (
			this.props.appointmentTypes[this.props.filters.appointmentTypeID] || {}
		);
	}
	
	get hasRestrictions() {
		return (this.appointmentType.rules || []).length > 0;
	}
	
	get genders() {
		return Object.values(this.props.genders || {}).map((_) => ({
			name: _.name,
			value: _.id,
		}));
	}
	
	get promptText() {
		if (!this.props.filters.appointmentTypeID) {
			return <I18n>selectAnAppointmentType</I18n>;
		}
		
		if (this.hasRestrictions) {
			
			return this.shouldShowAppointments ? (
				<I18n>selectDate</I18n>
			) : (
				<I18n>selectYourPets</I18n>
			);
		} else {
			return this.shouldShowPatients ? (
				<I18n>selectYourPets</I18n>
			) : (
				<I18n>selectDate</I18n>
			);
		}
	}
	
	get organization() {
		return this.props.organization || {};
	}
	
	get filteredAdministrators() {
		return this.administrators.filter((admin) => {
			if (this.props.filters.selectedAdministratorID) {
				return this.props.filters.selectedAdministratorID === admin.id;
			} else {
				return true;
			}
		});
	}
	
	get isWidgetAvailableAfter() {
		if (this.organization.widgetAvailability) {
			const [direction, amount, type] =
			this.organization.widgetAvailability.split("_");
			if (direction == "after") {
				return dayjs().add(amount, type).isAfter(this.startDate);
			} else {
				return true;
			}
		} else {
			return true;
		}
	}

	get isWidgetAvailableBefore() {
		if (this.organization.widgetAvailability) {
			const [direction, amount, type] =
			this.organization.widgetAvailability.split("_");
			if (direction == "before") {
				return dayjs().add(amount, type).isBefore(this.startDate);
			}
		} else {
			return true;
		}
	}
	
	// Render Method
	render() {
		const {SelectDark } = this.props;

		let patientStyle = [style.noPadding, style.patientContainer];

		if (!this.shouldShowPatients) {
			patientStyle.push(style.faded);
		}

		let administratorStyle = [];
		if (!this.shouldShowAppointments) {
			administratorStyle.push(style.faded);
		}
		if (this.isTimeSlotSelected()) {
			administratorStyle.push(style.mobileFaded);
		}

		return (
			<div className={style.timeSlots}>
				{!this.widgetSettings.condenseAdministrators && !this.shouldShowPatients && (
					<Container title="Appointment Filters" class={`${style.containerProviderSelect}`}>
						<SelectDark
							placeholder={I18n.t("allProviders")}
							onChange={this.setAdministrator}
							data={[
								{ value: null, name: I18n.t("allProviders") },
								...this.administrators.map((administrator) => ({
									value: administrator.id,
									name: `${administrator.firstName || ""} ${
										administrator.lastName || ""
									}`,
								})),
							]}
						/>
					</Container>
				)}
				<Row class={style.centered}>
                    <div className={`${style.promptContainer} ${!this.shouldShowPatients && style.promptDate}`}>
						{!this.isAllInfoGathered() && (
							<div class={style.flowPrompt}>
								<div class={style.promptText}>{this.promptText}</div>
							</div>
						)}
						{
							(!this.shouldShowPatients) && (
								<div className={style.btnCalendar}>
									<button onClick={()=>{
										this.setState((prevState) => {
											return { deployCalendar: !prevState.deployCalendar};
										});
									}}>
										<I18n>{this.startDate.format("MMM").toLocaleLowerCase()}</I18n>
										<img src={arrowDownIcon} alt="arrow down" />
									</button>
								</div>
							)
						}

                        {
                            this.state.deployCalendar && (
                                <div className={style.calendarContainer}>
                                    <Calendar startDate={this.startDate} selectedDateAction={this.handleDates}/>
                                </div>
                            )
                        }
                    </div>
					<div  className={`${style.dateContainer} ${administratorStyle.join(" ")}`}>
                        <Row class={style.dates}>
                            {
								times(5).map((i) => {
									const today = dayjs().startOf('day');
									const cloneStartDate = this.startDate.clone();
									const date = (i+1) === 3
									? cloneStartDate
									: (i+1) > 3
									? cloneStartDate.add(i-2, "days")
									: cloneStartDate.subtract(2-i, "days");

									const day = {
										text: date.format("ddd"),
										number: date.format("D"),
									};
									
									const dynamicStyle = [style.date];

									const isDisabled = date.isBefore(today);
									if(isDisabled) dynamicStyle.push(style.disabledDate);
									
									const isSame = this.startDate.isSame(date);
									if(isSame) dynamicStyle.push(style.selectedDate);

                                return (
                                    <Col 
                                        class={dynamicStyle} 
                                        onClick={() =>!isDisabled && this.handleDates(date)}
                                    >
                                        <Row class={style.day}>
                                            <I18n>{day.text.toLowerCase()}</I18n>
                                        </Row>
                                        <Row class={style.numberDay}>
                                            {day.number}
                                        </Row>
                                    </Col>
                                );
                            })}
                        </Row>
					</div>
				</Row>
				<Row class={style.addMarginTop}>
					<Col span={{ sm: 24}} class={patientStyle.join(" ")}>
						<PatientSelect onPatientSelect={this.handlePatientSelect} />
					</Col>
					{this.widgetSettings.condenseAdministrators && (
						<Col span={{ sm: 24, md: 6 }}>
							<div></div>
						</Col>
					)}
					<Col span={{sm: 24}} class={style.noPadding}>
						<Row class={`${style.timeSlotsCardContainer} ${administratorStyle.join(" ")}`}>
							<div class={style.headerContainer}><I18n>selectDoctorAndTime</I18n></div>
							{ this.administrators.length == 0 ? (
								this.state.loadingRegions ? (
									<div className={style.serviceRegionSpinner}>
										<LoadingIcon size={100}/>
									</div>
								) : (
									<div className={style.noBooking}>
										<I18n>noBooking</I18n>
									</div>
								)
							) : this.widgetSettings.condenseAdministrators ? (
								<TimeSlotsCard
									isWidgetAvailableAfter={this.isWidgetAvailableAfter}
									condensedAdministrators={true}
									processing={this.state.processing}
									startDate={this.startDate}
									timeSlots={this.condensedTimeSlots}
									onSelect={this.handleTimeSlotSelect}
									selectedTimeSlot={this.props.selectedTimeSlot}
									appointmentTypes={this.props.appointmentTypes}
									filters={this.props.filters}
									organization={this.props.organization}
									waitLists={this.props.waitLists}
									session={this.props.session}
								/>
							) : (
								this.filteredAdministrators.map((administrator, i) => {
									let timeSlots = this.getAdminTimeSlots(administrator);
									return (
										<TimeSlotsCard
											{...administrator}
											isWidgetAvailableAfter={this.isWidgetAvailableAfter}
											processing={this.state.processing}
											startDate={this.startDate}
											timeSlots={timeSlots}
											onSelect={this.handleTimeSlotSelect}
											selectedTimeSlot={this.props.selectedTimeSlot}
											handleSkipToNext={this.handleSkipToNext.bind(
												null,
												administrator
											)}
											filters={this.props.filters}
											appointmentTypes={this.props.appointmentTypes}
											outOfSlots={this.state.outOfSlots[administrator.id]}
											organization={this.props.organization}
											waitLists={this.props.waitLists}
											session={this.props.session}
										/>
									);
								})
							)}
						</Row>
					</Col>
				</Row>
				{
					!this.props.config.hideBackButton && !this.isAllInfoGathered() && (
						<Row>
							<Col span={{ sm: 24 }}>
								<Button type={"button"} theme={"gray"} onClick={this.handleBackButton} class={style.returnBtn}>
									<img src={chevronLeft} alt="Edit Icon"/>
									<span>
										<I18n>back</I18n>
									</span>
								</Button>
							</Col>
						</Row>
					)
				}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/templates/TimeSlots/index.js